import {
  RESET_PASSWORD_SENT_OTP,
  FORGOT_PASSWORD_CHECK_OTP,
  CHANGED_PASSWORD,
  VERIFY_EMAIL
} from "../actions/types";

const initialState = {
  // forgotData: {
  //   email: "",
  //   resend: ""
  // },
  verifyEmail: null,
  checkVerify: false,
  loading: true,
  checkEmailVerify:false,
  Verifyloading:true
};

const forgotPasswordReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case RESET_PASSWORD_SENT_OTP:
      return {
        ...state,
        // forgotData: payload,
        checkVerify: true,
        loading: false,
      };
    // case FORGOT_PASSWORD_CHECK_OTP:
    //   return {
    //     ...state,
    //     verifyEmail: payload,
    //     checkVerify: true,
    //     loading: false,
    //   };
    case CHANGED_PASSWORD:
      return {
        ...state,
        forgotData: null,
        verifyEmail: null,
        checkVerify: false,
        loading: false,
      };

      case VERIFY_EMAIL:
      return{
        ...state,
        checkEmailVerify: true,
         Verifyloading: false,
      }
    default:
      return state;
  }
};

export default forgotPasswordReducer;
